import React, { Component } from "react";
import PropTypes from "prop-types";

class Page extends Component {
  shouldComponentUpdate(nextProps) {
    const different = this.props.active !== nextProps.active;
    return different;
  }

  handleClick() {
    this.props.onClick(this.props.number, this.props.index);
  }

  render() {
    const { title, active } = this.props;

    if (active) {
      return (
        <a className="active item" style={{ padding: "12px" }}>
          <div className="pageTitle">{title}</div>
        </a>
      );
    }
    return (
      <a
        className="item"
        onClick={this.handleClick.bind(this)}
        style={{ padding: "12px" }}
      >
        <div className="pageTitle">{title}</div>
      </a>
    );
  }
}

Page.propTypes = {
  title: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  complete: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/index.js